import { SaleItemInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import price from '../../../../../assets/images/icons/price.svg'
import inventory from '../../../../../assets/images/icons/inventory.svg'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import copy from '../../../../../assets/images/icons/copy.svg'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'
import { SaleItemAttributes } from '../../../../../common/components/saleItemAttributes/SaleItemAttributes'

type Props = {
  startEdit: (el: SaleItemInterface) => void
  startDuplicate: (el: SaleItemInterface) => void
  el: SaleItemInterface
  showDetails: (el: SaleItemInterface) => void
}

export const ListItem = ({ startEdit, startDuplicate, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const imageUrl = useSelector(selectClusterImageUrl)

  const getFirstImage = () => {
    // Ищем первый файл, который не является постером и не видео
    const firstImage = el.files.find(
      (path) => !path.includes('poster_') && !path.includes('video_'),
    )
    return firstImage || el.files[0] // fallback на первый файл
  }

  const firstImage = getFirstImage()

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.imageContainer}>
          {firstImage && (
            <img className={classes.image} src={`${imageUrl + firstImage}`} alt={el.name} />
          )}
        </div>
        <div className={classes.filesLengthAnchor}>
          <div className={classes.filesLength}>{el.files.length}</div>
        </div>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description, 100)}</div>
        </div>

        <SaleItemAttributes attributes={el.attributes} />

        <div className={classes.settings}>
          <div className={el.isActive ? classes.settingsItem : classes.settingsItemInActive}>
            {el.isActive ? 'Активен' : 'Не активен'}
          </div>
          <div className={el.useStock ? classes.settingsItem : classes.settingsItemInActive}>
            {el.useStock ? 'Учет остатков' : 'Нет учета остатков'}
          </div>
          <div className={el.prices[0] ? classes.settingsItem : classes.settingsItemInActive}>
            {el.prices[0] ? 'Есть цена' : 'Нет цены'}
          </div>
        </div>
      </div>
      <div className={classes.buttons}>
        <IconButton
          display
          onClick={() => {
            showDetails(el)
          }}
          icon={search}
          alt="Детали"
          small
        />
        <IconButton
          display
          onClick={() => {
            startDuplicate(el)
          }}
          icon={copy}
          alt="Добавить вариант"
          small
        />
        <IconButton
          display
          onClick={() => {
            startEdit(el)
          }}
          icon={edit}
          alt="Изменить"
          small
        />
      </div>
    </div>
  )
}
